export default "__VITE_ASSET__1$mU9CZf__"